import React from "react";
import { RouteProps, Link } from "react-router-dom";
import { IActual } from "../../../services/api/Actual";
import Button from "../../../components/Form/Button";
import ItemBox from "../../../components/ItemBox";

interface GroupListProps extends RouteProps {
  data: IActual[];
  year: Number;
  month: Number;
}

const GroupList: React.FC<GroupListProps> = ({ data, year, month }) => {
  function renderRow(actual: IActual) {
    return (
      <li key={actual.groupId}>
        <ItemBox
          {...(actual.children ? { className: "hasChildren" } : { className: actual.status.slug })}
          name={actual.groupName + " - " + actual.groupCode}
        >
          {actual.groupParentId ? (
            <Link
              to={
                "/actual-update/" +
                actual.groupId +
                "/" +
                year +
                "/" +
                month
              }
            >
              <Button className="box__edit" title="Details" />
            </Link>
          ) : null}
        </ItemBox>

        {actual.children ? (
          <ul className="groups__list"> {actual.children.map(renderRow)}</ul>
        ) : null}
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">{data.map(renderRow)}</ul>
    </React.Fragment>
  );
};

export default GroupList;
